import type { ComicReaderViewMode } from '../../../lib/comicReaderModel'
import { ThemeLabeledSegment } from '../../theme/ThemeLabeledSegment'

const MODES = [
  { value: 'scroll' as const, label: '滚动' },
  { value: 'paginate' as const, label: '翻页' },
]

type Props = {
  angular: boolean
  mode: ComicReaderViewMode
  onChange: (mode: ComicReaderViewMode) => void
}

/** 阅读模式切换（滚动 / 翻页），选中态随主题 `--segment-active-*` */
export function ComicReaderModeToggle({ angular, mode, onChange }: Props) {
  return (
    <ThemeLabeledSegment
      angular={angular}
      value={mode}
      options={MODES}
      onChange={onChange}
      aria-label="阅读模式"
    />
  )
}
